<template>
  <div class="not-found-wrap flex">
    <p class="not-found-text bold" :style="styleObject">404</p>
    <p class="mb20 ft30">页面不存在</p>
    <div class="btn-wrap">
      <router-link to="/">
        <el-button type="primary" class="go-index-btn">返回首页</el-button>
      </router-link>
      <el-button class="back-btn" @click="$router.go(-1);">返回上一页</el-button>
    </div>
  </div>
</template>

<script>
export default{
  computed:{
    styleObject(){
      return 'color:'+this.$store.state.themeColor
    }
  }
}
</script>

<style>
.not-found-wrap{
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}
.not-found-text{
  font-size:250px;
}
.go-index-btn{
  margin-right:50px !important;
}
</style>
